export default {
  managerRoleScope: [
    'testimonials:read',
    'speakers:write',
    'general_settings:read',
    'general_settings:write',
    'blitz:write',
    'agenda:read',
    'agenda:write',
    'testimonials:write',
    'sponsors:read',
    'attendee_type:read',
    'listing:read',
    'sponsors:write',
    'user',
    'speakers:read',
    'listing:write',
    'blitz:read',
    'attendee_type:write'
  ],
  masterRoleScope: [
    'attendee_details',
    'testimonials:read',
    'speakers:write',
    'general_settings:read',
    'blitz:write',
    'agenda:read',
    'agenda:write',
    'awards:read',
    'general_settings:write',
    'registration:read',
    'testimonials:write',
    'attendee',
    'crypto_trader',
    'sponsors:read',
    'registration:write',
    'floor_plan:read',
    'awards:write',
    'attendee_type:read',
    'floor_plan:write',
    'listing:read',
    'master',
    'sponsors:write',
    'user',
    'speakers:read',
    'listing:write',
    'blitz:read',
    'attendee_type:write'
  ]
}



// WEBPACK FOOTER //
// ./src/utils/roleScopes.js